import { render, staticRenderFns } from "./PsPatientGeneralInformation.vue?vue&type=template&id=1ab8c11f&scoped=true&"
import script from "./PsPatientGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./PsPatientGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientGeneralInformation.vue?vue&type=style&index=0&id=1ab8c11f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8c11f",
  null
  
)

export default component.exports